import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Logo from './Logo';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        py: 6,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={3}>
            <Box sx={{ mb: 2 }}>
              <Logo />
            </Box>
            <Typography variant="body2" color="text.secondary" paragraph>
              Pioneering AI solutions for pharmacovigilance, making drug safety monitoring
              more intelligent, efficient, and reliable.
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Link
                href="https://www.linkedin.com/company/thrana-softech/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ textDecoration: 'none' }}
              >
                <IconButton 
                  color="primary" 
                  aria-label="LinkedIn"
                  sx={{ color: '#3c005a', '&:hover': { color: '#5c0080' } }}
                >
                  <LinkedInIcon />
                </IconButton>
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="h6" color="primary" gutterBottom sx={{ color: '#3c005a' }}>
              Quick Links
            </Typography>
            <Link 
              component={RouterLink} 
              to="/" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              Home
            </Link>
            <Link 
              component={RouterLink} 
              to="/about" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              About Us
            </Link>
            <Link 
              component={RouterLink} 
              to="/products" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              Products
            </Link>
            <Link 
              component={RouterLink} 
              to="/services" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              Services
            </Link>
            <Link 
              component={RouterLink} 
              to="/training" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              Training
            </Link>
            <Link 
              component={RouterLink} 
              to="/trainers" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              Trainers
            </Link>
            <Link 
              component={RouterLink} 
              to="/contact" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              Contact
            </Link>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="h6" color="primary" gutterBottom sx={{ color: '#3c005a' }}>
              Legal
            </Typography>
            <Link 
              component={RouterLink} 
              to="/privacy" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              Privacy Policy
            </Link>
            <Link 
              component={RouterLink} 
              to="/terms" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              Terms & Conditions
            </Link>
            <Link 
              component={RouterLink} 
              to="/cookies" 
              sx={{ 
                color: '#3c005a', 
                display: 'block', 
                mb: 1,
                // textDecoration: 'none',
                // '&:hover': {
                //   color: '#5c0080',
                // }
              }}
            >
              Cookies Policy
            </Link>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="h6" color="primary" gutterBottom sx={{ color: '#3c005a' }}>
              Contact Us
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Email: contact@thranatech.com
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Address: 2nd Floor, Sri Bhavani Arcade, No 7, Annaswamy Mudaliar Rd, Halasuru, Bengaluru-560042.
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} Thrana. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 